import { Wallet as EthersWallet } from '@ethersproject/wallet';
import { addHexPrefix } from '../../utils';
export class PrivateKey {
  constructor(privateKey) {
    this.privateKey = privateKey;
  }

  signTransaction(transaction) {
    const wallet = new EthersWallet(addHexPrefix(this.privateKey));
    return wallet.signTransaction(transaction);
  }

  signMessage(message) {
    const wallet = new EthersWallet(addHexPrefix(this.privateKey));
    return wallet.signMessage(message);
  }

  async getAddress() {
    const wallet = new EthersWallet(addHexPrefix(this.privateKey));
    return await wallet.getAddress();
  }

  async getPrivateKey() {
    return this.privateKey;
  }

}
//# sourceMappingURL=private-key.js.map